import { Dispatch } from 'redux'
import { AuthEventData } from '@chegg/wtf-components/dist/types/opencomponents/cheggAuth'
import {
  viewAuthSignInMode,
  viewAuthSignUpMode,
} from '@chegg-wt/core/state/instrumentation/actions'
import {
  setSelectedUserSignUpType,
  setSelectedUserSchoolType,
} from '@chegg-wt/core/state/user/actions'
import { ArgumentAction } from 'redux-logic/definitions/action'

type ReduxLogicDispatch = (action: ArgumentAction) => void

export const dispatchAuthEvent = (
  eventData: AuthEventData,
  dispatch: ReduxLogicDispatch | Dispatch
) => {
  const { eventInfo } = eventData
  if (eventInfo) {
    const {
      signup_viewed,
      signin_viewed,
      signup_user_type_selected,
      signup_student_type_selected,
      signup_teacher_teaching_in_selected,
    } = eventInfo

    const schoolType = signup_teacher_teaching_in_selected || signup_student_type_selected

    if (signin_viewed) {
      dispatch(viewAuthSignInMode())
      return
    }

    if (signup_viewed) {
      dispatch(viewAuthSignUpMode())
      return
    }

    if (signup_user_type_selected) {
      dispatch(setSelectedUserSignUpType({ memberRole: signup_user_type_selected }))
      return
    }

    if (schoolType) {
      dispatch(setSelectedUserSchoolType({ schoolType }))
    }
  }
}
